import { mapActions } from "vuex";

export default {
    methods: {
        ...mapActions({
            saveAll: 'crudStore/saveAll',
            assignDataForm: 'crudStore/assignDataForm',
        }),
        async actualizarFtn() {
            try {

            } catch {

            }
        },
        async saveForm(event) {
            try {
                if (event.ftn !== undefined) {
                    switch (event.ftn) {
                        case 'registroFtn':
                            await this.updateDataPost({
                                data: {
                                    data: [],
                                    route: 'save_all',
                                    auditar: true,
                                    notaDelete: null,
                                    tablaPost: ['info_egresos'],
                                    tablaDelete: []
                                }
                            })
                            if (event.pago === 1) {
                                let info_incapacidades = this.dataForm[this.namePath].info_incapacidades
                                info_incapacidades.deleted_at = this.fecha().fecha.delete
                                info_incapacidades.nota_delete = 'pago completado'
                                await this.assignDataForm({ state: 'info_incapacidades', data: info_incapacidades })
                                await this.updateDataPost({
                                    data: {
                                        data: [],
                                        route: 'save_all',
                                        auditar: true,
                                        notaDelete: null,
                                        tablaPost: ['info_egresos', 'info_incapacidades'],
                                        tablaDelete: []
                                    }
                                })
                            }
                            break;
                        case 'guardarFtn':
                            await this.updateDataPost({
                                data: {
                                    data: [],
                                    route: 'save_all',
                                    auditar: true,
                                    notaDelete: null,
                                    tablaPost: ['info_incapacidades'],
                                    tablaDelete: []
                                }
                            })
                            break;
                        case 'anularRegistroFtn':
                            let info_incapacidades = this.dataForm[this.namePath].info_incapacidades
                            info_incapacidades.deleted_at = this.fecha().fecha.delete
                            await this.assignDataForm({ state: 'info_incapacidades', data: info_incapacidades })
                            await this.updateDataPost({
                                data: {
                                    data: [],
                                    route: 'save_all',
                                    auditar: true,
                                    notaDelete: null,
                                    tablaPost: ['info_incapacidades'],
                                    tablaDelete: []
                                }
                            })
                            break;
                    }
                }

                let dataSave = await this.save(event.save)

                if (event.ftn === 'registroFtn') {
                    window.open(this.url + '/api/pdf/egresos?id=' + dataSave.ids.info_egresos.toString() + '&token=' + this.token, '_blank')
                }

                const await1 = this.getDataGet({ route: 'get_incapacidades', data: 'usuarios' })
                const await2 = this.resetDataIndex()
                const await3 = this.resetGlobal({ state: 'openModal' })
                const await4 = this.resetGlobal({ state: 'saveConfig/capa' })
                const await5 = this.resetDataForm()
                await await1
                await await2
                await await3
                await await4
                await await5
            } catch {

            }
        }
    },
}